export default __webpack_public_path__ + "static/media/how-it-serves-your-needs-02.c27c660c.jpg";